let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("koF4Z")).then(() => parcelRequire('8Cu3Q'));